define('views/dialog',[
    'models/base/modal',
    'views/base/modal'
], function(ModalModel, ModalView) {
    'use strict';
    var Dialog = {};

    Dialog.Button = {
        Yes: { caption: 'Да', className: 'btn-success', 'action': 'submit' },
        No: { caption: 'Нет', className: '', 'action': 'cancel' },
        Close: { caption: 'Закрыть', className: '', 'action': 'cancel' }
    };

    Dialog.Buttons = {
        YesNo: [
            Dialog.Button.Yes,
            Dialog.Button.No
        ],
        Close: [
            Dialog.Button.Close
        ]
    };

    Dialog.show = function(title, text, btns) {

        var dialog = {};

        dialog.model = new ModalModel({
            'title': title,
            'buttons': btns,
            'body': text
        });
        dialog.view = new ModalView({ model: dialog.model });

        dialog.model.on('action', function(action, cancel) {
            var act = dialog[action];
            if (act) {
                act(cancel);
            }
        });

        dialog.attach = function(parentView, name) {
            parentView.subview(name || 'modal', dialog.view);
            return this;
        };

        function onAction(name) {
            return function(fn) {
                dialog[name] = fn;
                return this;
            };
        }

        for (var i=0, li=btns.length; i<li; i++) {
            dialog[btns[i].action] = onAction(btns[i].action);
        }

        return dialog;
    };

    return Dialog;
});

